/**
 * Mic control matching Soren composer: mic-glyph at rest; stop square + timer when recording.
 */
import { useEffect, useState } from 'react'

export default function AnswerMicButton({
  listening,
  onToggle,
  disabled,
}: {
  listening: boolean
  onToggle: () => void
  disabled?: boolean
}) {
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    if (!listening) {
      setElapsed(0)
      return
    }
    const started = Date.now()
    const id = window.setInterval(() => {
      setElapsed(Math.floor((Date.now() - started) / 1000))
    }, 250)
    return () => window.clearInterval(id)
  }, [listening])

  const mm = String(Math.floor(elapsed / 60)).padStart(1, '0')
  const ss = String(elapsed % 60).padStart(2, '0')

  return (
    <button
      type="button"
      className={`cm-mic${listening ? ' recording' : ''}`}
      aria-label={listening ? 'Stop voice recording' : 'Speak your answer'}
      aria-pressed={listening}
      disabled={disabled}
      onClick={onToggle}
      data-testid="cm-mic"
    >
      {listening ? (
        <>
          <span className="cm-stop-square" aria-hidden="true" />
          <span className="cm-rec-timer" aria-hidden="true">{`${mm}:${ss}`}</span>
        </>
      ) : (
        <span className="cm-mic-glyph" aria-hidden="true" />
      )}
    </button>
  )
}
